import {Link as Routerlink} from 'react-router-dom'

const Link = (props) =>{
    return (
    <Routerlink style={{textDecoration:'none'}} to={props.to}>{props.children}</Routerlink>
    )
}

export default Link;